define('SiteSearch.RemoveFocus', [
    'SiteSearch.View',
    'SiteSearch.Button.View'
],
function SiteSearchFocus(
    SiteSearchView,
    SiteSearchButtonView
) {
    'use strict';

    SiteSearchButtonView.prototype.verifyShowSiteSearch = function verifyShowSiteSearch() {
        // This hide sitesearch when navigate
        this.application.getLayout().trigger('hideItemSearcher');
    };

    return {};
});

